module.exports = "/images/marker-icon-gold.png?2f087bac26dffa2dd37cf22c67e8b894";